export default __webpack_public_path__ + "static/media/semsPortalIcon.3679684c.png";